import React from 'react';
import { Alert } from 'components/ui/alert';
import { Card } from 'components/ui/card';
import { Icon } from 'components/ui/icon';
import { cn } from 'lib/utils';
import { Routes } from 'react-router-dom';
import { getinviteParams } from 'utils/inviteUrl';
import routeConfig from 'routes/config';
import { getConfig, getRoutes } from './helper';

const AuthLayout = (): JSX.Element => {
  // render auth routes + handler for invalid invite link

  const { invite } = getinviteParams(window.location.search);
  const isInvalidInvite = invite === 'DECLINED' || invite === 'EXPIRED';

  const renderInvalidMessage = () => {
    // route: /auth/?invite={invite_status}

    return (
      <Card
        className={cn(
          'border-0 shadow-none',
          'w-[472px] min-h-[252px] rounded-md pt-8 px-6 pb-9 shadow-md'
        )}
      >
        <h1 className="font-semibold text-xl leading-7 text-gray-blue-90">
          Invalid invite!
        </h1>
        <Alert
          className={cn(
            'flex items-start p-0 pt-2 px-2 m-0 mt-6 ',
            'bg-yellow-100 border border-yellow-550'
          )}
        >
          <Icon
            name="alert"
            size={16}
            className="pl-1 warningIcon text-gray-blue-70"
          />
          <div className="ml-2 pr-1 text-gray-blue-70">
            <strong className="body-subtext-semibold">
              This invite is invalid. It may be because of one of the following
              reasons:
            </strong>
            <ul className="pl-5">
              <li>Your invite link has expired</li>
              <li>Your invite link was not found</li>
              <li>You had declined the invite previously</li>
            </ul>
          </div>
        </Alert>
        <p className="mt-5 body-subtext-regular">
          Please contact your
          <strong className="body-subtext-semibold ml-1">admin</strong> for a
          new invite link.
        </p>
      </Card>
    );
  };

  return (
    <>
      {isInvalidInvite ? (
        renderInvalidMessage()
      ) : (
        <Routes>{getRoutes(getConfig(routeConfig.AUTH.layout))}</Routes>
      )}
    </>
  );
};

export default AuthLayout;
